import styled from 'styled-components';

export const ArticleContainer = styled.div`
    margin: 0 auto;
    ${(p) => p.theme.breakpoints.up('sm')} {
        max-width: ${(p) => p.theme.widths.article}px;
    }
`;
